<template>
  <v-container fluid class="employee-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
          centered
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-account-outline</v-icon>
            Employee
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-details`"
          >
            <v-icon class="mr-3">mdi-account-details</v-icon>
            Details
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-health`"
          >
            <v-icon class="mr-3">mdi-hospital-box</v-icon>
            Health
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-pin`"
          >
            <v-icon class="mr-3">mdi-lock</v-icon>
            Change Pin
          </v-tab>
          <v-tab></v-tab>

          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">Edit Employee</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'employeecode')"
                        v-bind:value="initvalue.employeecode"
                        placeholder="Employee Code"
                        persistent-hint
                        single-line hint="Enter the employee code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'employeename')"
                        v-bind:value="initvalue.employeename"
                        placeholder="Employee Name"
                        persistent-hint
                        single-line hint="Enter the employee name">
                      </v-text-field>

                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'employeetitle')"
                        v-bind:value="initvalue.employeetitle"
                        placeholder="Employee Title"
                        persistent-hint
                        single-line hint="Enter the employee title">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=employeetype
                        :value="initvalue.employeetype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'employeetype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the employee type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'employeestatus')"
                          v-bind:label="initvalue.employeestatus"
                          v-model="initvalue.employeestatus"
                          value="Active"
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'employeeicnum')"
                        v-bind:value="initvalue.employeeicnum"
                        placeholder="IC Num"
                        persistent-hint
                        single-line hint="Enter the employee IC">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=nationalities
                        :value="initvalue.employeenationality"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'employeenationality')"
                        placeholder="Nationality"
                        persistent-hint
                        single-line hint="Please choose the employee nationality">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items=gender
                        :value="initvalue.employeegender"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'employeegender')"
                        placeholder="Gender"
                        persistent-hint
                        single-line hint="Please choose the employee gender">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items=maritalstatus
                        :value="initvalue.employeemaritalstatus"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'employeemaritalstatus')"
                        placeholder="Marital Status"
                        persistent-hint
                        single-line hint="Please choose the employee marital status">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                        <v-menu
                          ref="menu_employeebirthdate"
                          v-model="menu_employeebirthdate"
                          :close-on-content-click="false"
                          :return-value.sync="employeebirthdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              v-model="employeebirthdate"
                              label="Employee Birthdate"
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on:change="updateChangedValue($event, 'employeebirthdate')"
                              v-bind:value="initvalue.employeebirthdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="employeebirthdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_employeebirthdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="updateChangedValue(employeebirthdate, 'employeebirthdate'); $refs.menu_employeebirthdate.save(employeebirthdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      <v-menu
                          ref="menu_employeestartdate"
                          v-model="menu_employeestartdate"
                          :close-on-content-click="false"
                          :return-value.sync="employeestartdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              v-model="employeestartdate"
                              label="Employment Start Date"
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on:change="updateChangedValue($event, 'employeestartdate')"
                              v-bind:value="initvalue.employeestartdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="employeestartdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_employeestartdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="updateChangedValue(employeestartdate, 'employeestartdate'); $refs.menu_employeestartdate.save(employeestartdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_employeeenddate"
                          v-model="menu_employeeenddate"
                          :close-on-content-click="false"
                          :return-value.sync="employeeenddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              v-model="employeeenddate"
                              label="Employment End Date"
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on:change="updateChangedValue($event, 'employeeenddate')"
                              v-bind:value="initvalue.employeeenddate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="employeeenddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_employeeenddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="updateChangedValue(employeeenddate, 'employeeenddate'); $refs.menu_employeeenddate.save(employeeenddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="9">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/employee/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editEmployee()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/employee/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            :value="'tab-details'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Employee Details</p>
                      <v-textarea
                        v-on:change="updateChangedDetail($event, 'employeeaddress')"
                        v-bind:value="initvalue.employeeaddress"
                        outlined
                        rows=3
                        label="Address"
                        hint="please enter the employee address"
                      ></v-textarea>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedDetail($event, 'employeeemail')"
                        v-bind:value="initvalue.employeeemail"
                        placeholder="Company Email"
                        persistent-hint
                        single-line hint="Enter the company email">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedDetail($event, 'employeeemail2')"
                        v-bind:value="initvalue.employeeemail2"
                        placeholder="Personal Email"
                        persistent-hint
                        single-line hint="Enter the personal email">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedDetail($event, 'employeephone')"
                        v-bind:value="initvalue.employeephone"
                        placeholder="Employee Phone"
                        persistent-hint
                        single-line hint="Enter the employee phone">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedDetail($event, 'employeemobile')"
                        v-bind:value="initvalue.employeemobile"
                        placeholder="Employee Mobile"
                        persistent-hint
                        single-line hint="Enter the employee mobile">
                      </v-text-field>

                      <div class="d-flex justify-center">
                        <v-btn
                            to="/employee/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editDetail()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            :value="'tab-health'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" md="3" sm="6">
                      <v-form>
                      <p class="text-h5">Edit Health Information</p>
                      <v-select
                        class="mb-4"
                        :items="vaccinetype"
                        outlined
                        dense
                        v-on:change="updateChangedHealth($event, 'vaccinationtype')"
                        v-bind:value="initvalue.health.vaccinationtype"
                        v-bind:error="errorindex == 2"
                        placeholder="Vaccine Type"
                        persistent-hint
                        single-line hint="Please choose the vaccine type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="vaccinestatus"
                        outlined
                        dense
                        v-on:change="updateChangedHealth($event, 'vaccinationstatus')"
                        v-bind:value="initvalue.health.vaccinationstatus"
                        v-bind:error="errorindex == 0 || errorindex == 1 || errorindex == 2"
                        placeholder="Vaccination Status"
                        persistent-hint
                        single-line hint="Please choose the vaccination status">
                      </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3" sm="6">
                      <v-form>
                      <p class="text-h5">&nbsp;</p>
                        <v-menu
                          ref="menu_vaccinationdate1"
                          v-model="menu_vaccinationdate1"
                          :close-on-content-click="false"
                          :return-value.sync="vaccinationdate1"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              v-model="vaccinationdate1"
                              label="Vaccination First Dose"
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on:change="updateChangedHealth($event, 'vaccinationdate1')"
                              v-bind:value="initvalue.health.vaccinationdate1"
                              v-bind:error="errorindex == 0"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="vaccinationdate1"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_vaccinationdate1 = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="updateChangedHealth(vaccinationdate1, 'vaccinationdate1'); $refs.menu_vaccinationdate1.save(vaccinationdate1)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_vaccinationdate2"
                          v-model="menu_vaccinationdate2"
                          :close-on-content-click="false"
                          :return-value.sync="vaccinationdate2"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              v-model="vaccinationdate2"
                              label="Vaccination Second Dose"
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on:change="updateChangedHealth($event, 'vaccinationdate2')"
                              v-bind:value="initvalue.health.vaccinationdate2"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="vaccinationdate2"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_vaccinationdate2 = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="updateChangedHealth(vaccinationdate2, 'vaccinationdate2'); $refs.menu_vaccinationdate2.save(vaccinationdate2)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-switch
                          color="primary"
                          v-on:change="updateChangedHealth($event, 'vaccinationshareconsent')"
                          v-bind:label="initvalue.health.vaccinationshareconsent ? 'Employee consents to sharing Vaccination Status' : 'Employee does not consent to sharing Vaccination Status' "
                          v-model="initvalue.health.vaccinationshareconsent"
                      ></v-switch>
                    </v-form>
                  </v-col>
                </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6" sm="5">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/employee/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editHealth()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-pin'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Pin</p>
                      <v-text-field
                          class="mb-4"
                          outlined
                          dense
                          value=""
                          v-model="pin.employeepin"
                          v-bind:error="pin.error"
                          placeholder="New Pin"
                          persistent-hint
                          single-line hint="Enter employee pin. Min 6 digits long">
                      </v-text-field>
                      <v-text-field
                          class="mb-4"
                          outlined
                          dense
                          value=""
                          v-model="pin.employeepin2"
                          v-bind:error="pin.error2"
                          placeholder="Verify Pin"
                          persistent-hint
                          single-line hint="Confirm employee pin. Min 6 digits long">
                      </v-text-field>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/employee/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPin()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item></v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      employee: {},
      detail: {},
      photo: {},
      employeebirthdate: null,
      employeestartdate: null,
      employeeenddate: null,
      vaccinationdate1: null,
      vaccinationdate2: null,
      menu_employeebirthdate: false,
      menu_employeestartdate: false,
      menu_employeeenddate: false,
      menu_vaccinationdate1: false,
      menu_vaccinationdate2: false,
      vaccinetype: ["Moderna", "Pfizer", "Sinovac", "Sinopharm", "Sputnik", "Other"],
      vaccinestatus: ["None", "Partial Vaccination", "Full Vaccination"],
      pin: {
        error: false,
        error2: false
      },
      initvalue: {

      },
      health: {
          vaccinationtype: '',
          vaccinationstatus: '',
          vaccinationdate1: '',
          vaccinationdate2: '',
          vaccinationshareconsent: false,
      },
      imageurl: undefined,
      employeetype: ['Full Time', 'Part Time', 'Contract'],
      gender: ['Male', 'Female'],
      maritalstatus: ['Single', 'Married'],
      nationalities: ['American', 'British', 'Cambodian', 'Chinese', 'Filipino', 'Indian', 'Indonesian', 'Malaysian', 'Myanmar', 'Singaporean'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  methods: {
    ...mapActions('Employee', ['updateEmployeeRequest','updateEmployeeImageRequest','updateEmployeePinRequest','getEmployeesRequest']),
    checkError(){
      console.log(this.health);
      if(this.health.vaccinationstatus=='Partial Vaccination' 
          && (this.health.vaccinationdate1==null || this.health.vaccinationdate1.trim()=="")){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(this.health.vaccinationstatus=="Full Vaccination" 
          && (this.health.vaccinationdate1==null || this.health.vaccinationdate2==null)){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(this.health.vaccinationtype=="Other" 
          && (this.health.vaccinationstatus=="Partial Vaccination" || this.health.vaccinationstatus=="Full Vaccination")){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    editEmployee() {
      this.employee._id = this.initvalue._id;
      this.updateEmployeeRequest(this.employee);
      this.getEmployeesRequest();
      router.push('/employee/list');
    },
    editDetail() {
      this.detail._id = this.initvalue._id;
      this.updateEmployeeRequest(this.detail);
      this.getEmployeesRequest();
      router.push('/employee/list');
    },
    editHealth() {
      if(this.checkError() == false) return;
      let json = {}
      json._id = this.initvalue._id;
      json.health = this.health;
      console.log(json);
      this.updateEmployeeRequest(json);
      this.getEmployeesRequest();
      router.push('/employee/list');
    },
    editPhoto() {
      console.log(this.photo)
      this.photo._id = this.initvalue._id;
      this.updateEmployeeImageRequest(this.photo);
      this.getEmployeesRequest();
      router.push('/employee/list');
    },
    editPin() {
      console.log(this.pin);
      if(this.pin.employeepin == undefined || this.pin.employeepin.length<6){
        this.pin.error = true;
        return;
      }
      this.pin.error = false;
      if(this.pin.employeepin !== this.pin.employeepin2){
        this.pin.error2 = true;
        return;
      }
      this.pin.error2 = false;
      this.pin._id = this.initvalue._id;
      console.log(this.pin);
      this.updateEmployeeRequest(this.pin);
      this.getEmployeesRequest();
      router.push('/employee/list');
    },
    updateChangedValue(value, field){
      this.employee[field] = value;
    },
    updateChangedHealth(value, field){
      this.health[field] = value;
    },
    updateChangedDetail(value, field){
      this.detail[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.employeeimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('Employee', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    this.imageurl = this.initvalue.employeeimage;

    if(this.initvalue.health!==undefined){
      this.health = this.initvalue.health;
      if(this.initvalue.employeebirthdate!==null){
        let d1 = new Date(this.initvalue.employeebirthdate);
        let month = d1.getMonth()<9 ? "0" + (d1.getMonth()+1).toString() : (d1.getMonth()+1).toString();
        this.employeebirthdate = d1.getFullYear() + "-" + month + "-" + d1.getDate();
      }
      if(this.initvalue.employeestartdate!==null){
        let d1 = new Date(this.initvalue.employeestartdate);
        let month = d1.getMonth()<9 ? "0" + (d1.getMonth()+1).toString() : (d1.getMonth()+1).toString();
        this.employeestartdate = d1.getFullYear() + "-" + month + "-" + d1.getDate();
      }
      if(this.initvalue.employeeenddate!==null){
        let d1 = new Date(this.initvalue.employeeenddate);
        let month = d1.getMonth()<9 ? "0" + (d1.getMonth()+1).toString() : (d1.getMonth()+1).toString();
        this.employeeenddate = d1.getFullYear() + "-" + month + "-" + d1.getDate();
      }
      if(this.initvalue.health.vaccinationdate1!==null){
        let d1 = new Date(this.initvalue.health.vaccinationdate1);
        let month = d1.getMonth()<9 ? "0" + (d1.getMonth()+1).toString() : (d1.getMonth()+1).toString();
        this.vaccinationdate1 = d1.getFullYear() + "-" + month + "-" + d1.getDate();
      }
      if( this.initvalue.health.vaccinationdate2!==null){
        let d2 = new Date(this.initvalue.health.vaccinationdate2);
        let month = d2.getMonth()<9 ? "0" + (d2.getMonth()+1).toString() : (d2.getMonth()+1).toString();
        this.vaccinationdate2 = d2.getFullYear() + "-" + month + "-" + d2.getDate();
      }
    } else {
      this.initvalue.health = this.health;
    }


    console.log(this.initvalue);
    if(!this.initvalue._id) this.$router.push({ name: 'EmployeeList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
